import { render, staticRenderFns } from "./newContribution.vue?vue&type=template&id=af764438&scoped=true&"
import script from "./newContribution.vue?vue&type=script&lang=js&"
export * from "./newContribution.vue?vue&type=script&lang=js&"
import style0 from "./newContribution.vue?vue&type=style&index=0&id=af764438&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af764438",
  null
  
)

export default component.exports